import { render, staticRenderFns } from "./anchorAfan.vue?vue&type=template&id=0856ef7b&scoped=true&lang=pug"
import script from "./anchorAfan.vue?vue&type=script&lang=js"
export * from "./anchorAfan.vue?vue&type=script&lang=js"
import style0 from "./anchorAfan.vue?vue&type=style&index=0&id=0856ef7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0856ef7b",
  null
  
)

export default component.exports